var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"config-frame",attrs:{"src":"/3d-viewer/index.html","title":"Umbrella Model Viewer","height":"100%","width":"100%","id":"viewer"},on:{"~pcloaded":function($event){return _vm.frameLoaded.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }